import * as yup from 'yup';
import { AppTFunction } from '@retail/app/i18n';

export const priceSchema = (t: AppTFunction) =>
  yup.number().price(t).required(t('validation.required'));

export const priceListSchema = (t: AppTFunction) =>
  yup.object({
    prices: yup.array(yup.object({ price: priceSchema(t) })),
  });

export type PriceListSchema = yup.InferType<ReturnType<typeof priceListSchema>>;

export const defaultPriceListValues: PriceListSchema = {
  prices: [
    { price: 5.76 },
    { price: 61.55 },
    { price: 127.01 },
    { price: 904.8 },
    { price: 3528.65 },
  ],
};
